import { useRef, useEffect } from "react";

function useDocumentTitle(title, prevailOnUnmount = false) {
    const defaultTitle = useRef(document.title);

    useEffect(() => {
        document.title = title;
    }, [title]);

    // Read through a ref so the cleanup registers once, at mount, but still
    // sees the current value when it eventually runs. Listing
    // `prevailOnUnmount` as a dependency instead would tear down and
    // re-register the cleanup every time it changed, which is not what
    // "restore the title on unmount" means.
    const prevailRef = useRef(prevailOnUnmount);
    prevailRef.current = prevailOnUnmount;

    useEffect(
        () => () => {
            if (!prevailRef.current) {
                document.title = defaultTitle.current;
            }
        },
        []
    );
}

export default useDocumentTitle;
